import { DEFAULT_API_CONFIG } from './apiConfig';
import { downloadExcelFileToBrowser } from '../helpers/excelFileDownload';
import { createNewUserWithRole } from './account.service';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}`;
const baseVapiRoute = `https://api.vapi.ai`;

export const getCallPayload = async id => {
  const url = `${baseRoute}/callAgent/getCallPayload/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const startVapiCall = async payload => {
  const url = `${baseVapiRoute}/call`;

  let headers = getHeaders();
  headers.Authorization = `Bearer ${process.env.REACT_APP_VAPI_API_KEY}`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const getVapiCallStatus = async id => {
  const url = `${baseVapiRoute}/call/${id}`;
  let headers = getHeaders();
  headers.Authorization = `Bearer ${process.env.REACT_APP_VAPI_API_KEY}`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getVapiActiveCalls = async queryParams => {
  const query = queryString.stringify(queryParams);
  const url = `${baseRoute}/callAgent/vapiActiveCalls?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getVapiCallHistory = async queryParams => {
  const query = queryString.stringify(queryParams);
  const url = `${baseRoute}/callAgent/vapiCallHistory?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getVapiCallAnalysis = async id => {
  const url = `${baseRoute}/callAgent/vapiCallAnalysis/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getVapiRecordingUrl = id => `${baseRoute}/callAgent/vapiRecording/${id}`;

export const getVapiFlaggedCalls = async queryParams => {
  const query = queryString.stringify(queryParams);
  const url = `${baseRoute}/callAgent/vapiFlaggedCalls?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getVapiFailedCalls = async queryParams => {
  const query = queryString.stringify(queryParams);
  const url = `${baseRoute}/callAgent/vapiFailedCalls?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const exportCallHistory = async (startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const query = queryString.stringify(params);
  const reqUrl = `${baseRoute}/callAgent/exportCallHistory?${query}`;
  let headers = getHeaders();
  const response = await fetch(reqUrl, { method: 'GET', headers });
  if (response.status === 204) throw new Error('No records to export');
  if (!response.ok) throw new Error('Export failed');
  const json = await response.json();
  const dateLabel = startDate || endDate ? `_${(startDate || 'all').slice(0, 10)}_to_${(endDate || 'now').slice(0, 10)}` : '';
  downloadExcelFileToBrowser(json, `CallHistory${dateLabel}.xlsx`);
};

export const exportNeedsAttention = async (startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const query = queryString.stringify(params);
  const reqUrl = `${baseRoute}/callAgent/exportNeedsAttention?${query}`;
  let headers = getHeaders();
  const response = await fetch(reqUrl, { method: 'GET', headers });
  if (response.status === 204) throw new Error('No records to export');
  if (!response.ok) throw new Error('Export failed');
  const json = await response.json();
  const dateLabel = startDate || endDate ? `_${(startDate || 'all').slice(0, 10)}_to_${(endDate || 'now').slice(0, 10)}` : '';
  downloadExcelFileToBrowser(json, `NeedsAttention${dateLabel}.xlsx`);
};

export const exportCallQueue = async () => {
  const reqUrl = `${baseRoute}/callAgent/exportCallQueue`;
  let headers = getHeaders();
  const response = await fetch(reqUrl, { method: 'GET', headers });
  if (response.status === 204) throw new Error('No records to export');
  if (!response.ok) throw new Error('Export failed');
  const json = await response.json();
  downloadExcelFileToBrowser(json, `CallQueue.xlsx`);
};

export const flagCall = async id => {
  const url = `${baseRoute}/callAgent/vapiFlagCall/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getCallMetrics = async (startDate, endDate) => {
  const params = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const query = queryString.stringify(params);
  const reqUrl = `${baseRoute}/callAgent/callMetrics?${query}`;
  let headers = getHeaders();
  const response = await fetch(reqUrl, { method: 'GET', headers });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const releaseCall = async id => {
  const url = `${baseRoute}/callAgent/vapiReleaseCall/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
